// extracted by mini-css-extract-plugin
module.exports = {"inner":"PP0gK","block":"dNyn0","hide_mobile":"sAVr4","iconContainer":"nMi97","pviIcon":"Ot1mB"};